import React, { useEffect, useState } from 'react'
import useCreatePaymentRequest from '../../Hooks/Payments/useCreatePaymentRequest';
import useApplyCoupon from '../../Hooks/Payments/useApplyCoupon';
import { useSelector } from 'react-redux';
import { ButtonWithIcon, Loader } from '../../constents/components';
import { Navigate, useNavigate } from 'react-router-dom';
import { SmartHiring, EndToEndHiring, mockPlans } from '../../constents/Plans/plansDetails';
import PaymentSuccessPopup from './PaymentSuccessPopup';

const PaymentsValidation = ({ createPaymentOrder, showSuccessPopup, planDetails, onClosePopup, onCouponCodeApplied }) => {
  // console.log('planDetails in payment validation:', planDetails);
  // console.log('showSuccessPopup in payment validation:', showSuccessPopup);
  // console.log('onClosePopup in payment validation:', onClosePopup);
  const [couponCode, setCouponCode] = useState('');
  const [couponCodeToSend, setCouponCodeToSend] = useState('');
  const query = new URLSearchParams(window.location.search);
  const plan_type = query.get('plan_type');
  const plan_name = query.get('plan_name');
  const [couponVerificationLoading, couponVerificationError, couponData, verificationFuntion] = useApplyCoupon(couponCode);
  const plansDetails = { 'MOCK': mockPlans };

  const planDataToShow = plansDetails?.[plan_type]?.find(item => item.planName === plan_name);
  const planNameToShow = planDataToShow?.name ?? planDataToShow?.des;
  const mrpToShow = planDataToShow?.mrp;

  const priceToPay = couponData?.discount ? mrpToShow - couponData?.discount : mrpToShow;

  const ApplyCoupon = () => verificationFuntion({ plan_type, plan_name, couponCode });
  useEffect(() => {
    if (couponData?.success === true) {
      setCouponCodeToSend(couponCode);
      onCouponCodeApplied(couponCode);
    }
  }, [couponData, couponCode, onCouponCodeApplied])

  // console.log('coupon code to send:', couponCodeToSend);

  return (
    <>
      <PaymentSuccessPopup 
        isVisible={showSuccessPopup}
        onClose={onClosePopup}
        planDetails={planDetails}
      />
      <div className=' flex flex-col justify-center gap-2 w-[36rem] bg-white p-4 rounded-xl'>
        <div className=' flex justify-between items-end'>
          <h1 className=' text-black text-lg font-semibold'>Plan Name</h1>
          <p className=' text-gray-600'>{planNameToShow}</p>
        </div>

        <div className=' flex justify-between items-end'>
          <h1 className=' text-black text-lg font-semibold'>MRP</h1>
          <p className=' text-gray-600'>₹{mrpToShow}</p>
        </div>

        <div className='my-2 flex justify-between items-start'>
          <h1 className=' text-black text-sm font-semibold'>Have a coupon code?</h1>
          <div>
            <input className=' outline-none border-b-[2px] borer-gray-900' type="text" value={couponCode} onChange={(e) => setCouponCode(e.target.value)} />

            {(() => {
              if (couponCode) {
                if (couponData?.success === false) {
                  return <p className='text-end mt-1 text-sm text-red-600'>{couponVerificationError}</p>;
                }
                else if (couponData?.success === true) {
                  return (<p className=' mt-1 text-end text-sm text-green-600'>Applied</p>)
                }
                else if (couponVerificationLoading) {
                  return (<p className='  mt-1 text-end text-sm text-red-600'>Checking...</p>)
                } else {
                  return (<p className=' text-end mt-1 cursor-pointer text-sm text-primary-color-900 underline' onClick={ApplyCoupon}>Apply</p>)
                }
              }
            })()
            }
          </div>
        </div>

        <button
          onClick={() => createPaymentOrder(couponCodeToSend)}
          className='flex justify-center bg-primary-color-900 gap-2 rounded-xl px-4 py-2 cursor-pointer'>
          <span className=' text-white '>Pay ₹{priceToPay >= 0 ? priceToPay : 0}</span>
        </button>
      </div>
    </>
  )
}

const PaymentsLoader = () => {
  return (<div className=' flex flex-col justify-center gap-4 w-[36rem] bg-white p-4 rounded-xl'>
    <Loader />
    <h2 className=' text-center'>we are processing your payment</h2>
  </div>)
}

const PaymentSucess = ({ planDetails, onBackToPayments }) => {
  const redirect = useNavigate();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown(prev => {
        if (prev <= 1) {
          clearInterval(timer);
          onBackToPayments();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [onBackToPayments]);

  return (
    <div className='flex flex-col justify-center gap-4 w-[36rem] bg-white p-4 rounded-xl'>
      <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
        <svg className="w-8 h-8 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
        </svg>
      </div>
      <div className='flex justify-center'>
        <span className='text-gray-800 text-xl font-semibold'>Payment Successful!</span>
      </div>
      <p className='text-center text-gray-600'>
        Redirecting back in {countdown} seconds...
      </p>
    </div>
  )
}

const PaymentError = () => {
  return (<div className=' flex flex-col justify-center gap-4 w-[36rem] bg-white p-4 rounded-xl'>
    <h2 className=' text-center'>Your transaction is failed, If any amount deducted from account we recomend you to contact our support team.</h2>
  </div>)
}

const Purchase = () => {
  const [loadingForPayment, errorForPayment, statusForPayment, paymetRequestCreater] = useCreatePaymentRequest();
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showPaymentForm, setShowPaymentForm] = useState(true);
  const [couponCode, setCouponCode] = useState('');
  
  const query = new URLSearchParams(window.location.search);
  const plan_type = query.get('plan_type');
  const plan_name = query.get('plan_name');
  
  // Get plan details for popup
  const plansDetails = { 'MOCK': mockPlans };
  const planDataToShow = plansDetails?.[plan_type]?.find(item => item.planName === plan_name);
  const planDetails = {
    planName: planDataToShow?.name || plan_name,
    amount: planDataToShow?.mrp || 0
  };

  const createPaymentOrder = (coupon_code) => paymetRequestCreater({ plan_name, plan_type, coupon_code });

  const status = statusForPayment;
  const loading = loadingForPayment;
  const error = errorForPayment;

  // Show success screen first, then return to payment form with popup
  useEffect(() => {
    // console.log('Status changed:', status, 'statusForPayment:', statusForPayment, 'statusForZeroPayment:', statusForZeroPayment);
    if (status === true) {
      // console.log('Setting showPaymentForm to false');
      setShowPaymentForm(false); // Show success screen first
    }
  }, [status, statusForPayment]);

  const handleBackToPayments = () => {
    // console.log('handleBackToPayments called - setting popup to true');
    setShowPaymentForm(true); // Return to payment form
    setShowSuccessPopup(true); // Show popup on return
  };

  const handleClosePopup = () => {
    setShowSuccessPopup(false);
  };

  console.log('Purchase component state:', { showSuccessPopup, showPaymentForm, status, loading, error });

  return (
    <div className=' flex items-center justify-center'>
      {
        loading ? <PaymentsLoader /> : 
        error ? <PaymentError /> : 
        status === true && !showPaymentForm ? (
          <PaymentSucess planDetails={planDetails} onBackToPayments={handleBackToPayments} />
        ) : (
          <PaymentsValidation 
            createPaymentOrder={createPaymentOrder}
            showSuccessPopup={showSuccessPopup}
            planDetails={planDetails}
            onClosePopup={handleClosePopup}
            onCouponCodeApplied={setCouponCode}
          />
        )
      }
    </div>
  )
}
export default Purchase;
